import { render, staticRenderFns } from "./RekognitionManagement.vue?vue&type=template&id=0c2bcb8a&"
import script from "./RekognitionManagement.vue?vue&type=script&lang=js&"
export * from "./RekognitionManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports